<!--
  创建时间：2024/8/23 17:30
  创建人：toyehuang
  文件描述：FriendlyLink 友情链接
-->

<template>
  <div class="friendly-link mt-30">
    <div class="friendly-link-head f-b-c">
      <h3>友情链接</h3>
      <div>
        <el-button type="primary" icon="el-icon-arrow-left" size="mini" plain :disabled="isFirstPage" @click="pagePrev" />
        <el-button type="primary" icon="el-icon-arrow-right" size="mini" plain class="ml-10" :disabled="isLastPage" @click="pageNext" />
      </div>
    </div>
    <ul class="friendly-link-list">
      <li v-for="link in listData" :key="link.id" class="friendly-link-item">
        <Link :to="link.url || ''" :title="link.name" class="flex-center">
          <img :src="link.image" :alt="link.name">
        </Link>
      </li>
    </ul>
  </div>
</template>

<script>
import Link from "@/layout/components/LayoutHead/HeadNav/Link.vue";
import linkApi from "@/api/link";
import { LINK_TYPE } from "@/utils/constant";

export default {
  name: "FriendlyLink",
  components: { Link },
  props: {
  },
  data() {
    return {
      listData: [],
      showListData: [],
      pageNo: 1,
      total: 0,
      pageSize: 10
    };
  },
  // 监听属性 类似于data概念
  computed: {
    isFirstPage() {
      return this.pageNo <= 1
    },
    isLastPage() {
      return this.pageNo >= Math.ceil(this.total / this.pageSize)
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.getListData()
  },
  // 方法集合
  methods: {
    getListData() {
      linkApi
        .page({
          type: LINK_TYPE.FRIENDLY_LINK,
          pageNo: this.pageNo,
          pageSize: this.pageSize
        })
        .then((res) => {
          this.listData = res.data?.list || [];
          this.total = res.data?.total ?? 0
        });
    },
    pagePrev() {
      this.pageNo -= 1
      this.getListData()
    },
    pageNext() {
      this.pageNo += 1
      this.getListData()
    }
  }
};
</script>

<style scoped lang="scss">
.friendly-link{
  .friendly-link-head{
    height: 40px;
    border-bottom: 2px solid #eee;
    margin-bottom: 10px;
    h3{
      line-height: 40px;
      color: #333;
      font-weight: bold;
      font-size: 24px;
      position: relative;
      &:after{
        content: '';
        display: block;
        width: 100%;
        height: 2px;
        background-color: $--color-primary;
        position: absolute;
        left: 0;
        bottom: 0;
        transform: translateY(50%);
      }
    }
		::v-deep{
			.el-button--mini{
				padding: 5px;
			}
			.el-button--primary.is-plain.is-disabled{
				color: #fff;
				background-color: #c8c9cc;
				border-color: #c8c9cc;
			}
		}
  }
  .friendly-link-list{
    height: 200px;
    display: flex;
    flex-flow: row wrap;
    .friendly-link-item{
      height: 78px;
      width: 232px;
      border: 1px solid #eee;
      margin-top: 10px;
      margin-right: 10px;
      padding: 10px;
      a{
        width: 100%;
        height: 100%;
        img{
          max-width: 100%;
          max-height: 100%;
          object-fit: contain;
        }
      }
      &:nth-of-type(5n) {
        margin-right: 0;
      }
      &:hover{
        border-color: $--color-primary;
        img{
          opacity: 0.8;
        }
      }
    }
  }
}
</style>
